<div class="modal-header">
  <h2 i18n="@@ts.quote.quote_saved">Quotation Successfully Saved</h2>
  <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="activeModal.dismiss()">
    <svg version="1.1" x="0px" y="0px" width="14" height="14" viewBox="0 0 14 14">
      <path class="icon-stroke" fill="none" stroke-width="2" stroke-linecap="square"d="M2.8,11.2l8.5-8.5 M2.8,2.8l8.5,8.5" />
    </svg>
  </button>
</div>
<div class="modal-footer">
  <!-- <ng-container  *ngIf="invResponse"> -->
  <input type="text" value="{{ quotationUrl }}" readonly #quotationLinkInput />
  <button type="button" class="tu-btn blue" (click)="copyLink(quotationLinkInput)" i18n="@@quotation.copy_link">Copy
    Link</button>
  <!-- </ng-container> -->
</div>
